import { useAuth } from '../context/AuthContext'
import Button from '../components/common/Button'

const initialsOf = (name) =>
  String(name || '?')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase()

/**
 * The account.
 *
 * Written in Tagalog like the order form. The screen was English throughout; the app-wide
 * sweep has not run yet, so this one went first because it was the one being touched.
 *
 * **The remembered places are not here.** They were, briefly, and they belong on the row
 * they appear on instead — a place is renamed at the moment somebody looks at its name and
 * finds it wrong, which is in the picker, not in a settings screen they would have to think
 * to visit. See `PlacePicker`.
 */
export default function Settings() {
  const { user, signOut } = useAuth()

  return (
    <section className="px-5 pt-[18px] pb-7">
      <h1 className="font-display font-bold text-display-l text-ink">Account</h1>

      <div className="flex items-center gap-3.5 mt-5">
        {user?.photoURL ? (
          <img
            src={user.photoURL}
            alt=""
            className="w-[52px] h-[52px] flex-none rounded-full object-cover border border-hairline"
          />
        ) : (
          <div className="w-[52px] h-[52px] flex-none rounded-full grid place-items-center bg-blush text-brand text-[17px] font-bold">
            {initialsOf(user?.displayName)}
          </div>
        )}

        <div className="min-w-0">
          <p className="text-body font-semibold text-ink">{user?.displayName ?? '—'}</p>
          <p className="mt-0.5 text-body-s text-ink-3 break-all">{user?.email ?? '—'}</p>
        </div>
      </div>

      {/* Read only: Google owns these, and no endpoint would save an edit. */}
      <p className="mt-3.5 text-body-s text-ink-3">
        Ang pangalan, larawan at email mo ay galing sa Google account na ginamit mo sa
        pag-sign in. Doon mo sila palitan at susunod sila dito.
      </p>

      <Button variant="ghost" onClick={signOut} className="w-full mt-[22px]">
        Mag-sign out
      </Button>
    </section>
  )
}
